import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import MessageType from '../../../enums/MessageType';
import BasketItemsProptype from '../../../propTypes/BasketItems.proptype';
import Message from '../../../v2/components/ui/Message/Message';
import Language from '../../../v2/lang/language';
import Translation from '../../../v2/lang/Translation';
import Spacing from '../../../v2/style-helper/Spacing';

const useStyles = createUseStyles({
  deliveryOptionNonShippableMessage: {
    margin: props => !props.removeMargin && [Spacing.single, 0, Spacing.triple, 0],
    marginBottom: props => props.isOverlay && Spacing.triple,
  },
});

function DeliveryOptionNonShippableMessage(props) {
  const classes = useStyles({...props});
  
  const getQuantity = () => {
    const basketItemQuantity = props.basketItems?.[0].quantity;
    const basketItemAvailableQuantity = props.basketItems?.[0].availableQuantity;
    if (basketItemQuantity > basketItemAvailableQuantity) {
      return [basketItemAvailableQuantity, basketItemQuantity - basketItemAvailableQuantity];
    }
    return [];
  };
  
  return (
    <div className={classes.deliveryOptionNonShippableMessage} data-test="DeliveryOptionNonShippableMessage">
      <Message type={MessageType.ERROR}>
        {Language.formatLinkText(
          Translation.getText(`deliveryOptions.errors.${props.unshippableReason}`, getQuantity()),
          {href: `${window.siteObj.siteHomePage}my.basket`},
        )}
      </Message>
    </div>
  );
}

DeliveryOptionNonShippableMessage.propTypes = {
  isOverlay: PropTypes.bool.isRequired,
  unshippableReason: PropTypes.string.isRequired,
  basketItems: PropTypes.arrayOf(PropTypes.shape(BasketItemsProptype)).isRequired,
};

export default DeliveryOptionNonShippableMessage;
